export const appRoutes = {
  HOME: "/",
  ABOUT: "about-us",
  SUSTENIBILITY: "sustenibility",
  APARTMENTS: "apartments",
  CONTACT: "contact-us",
  PRIVACY: "privacy-policy",
  COFINANCED: "progetti-cofinanziati",
};
